/**
 * Created by sasik on 10/13/15.
 */




var sortOrder = 1;

var Arrow = {

    up : 'glyphicon-arrow-up',

    down: 'glyphicon-arrow-down',

    /**
     * @param arrowType this.up || this.down
     * @returns {string} html
     */
    htmlTemplate: function (arrowType) {
        return '<span class="glyphicon ' + arrowType +'"></span>'
    },

    handle: function($elem, sortOrder) {
        var span = $('th span.glyphicon').remove();
        $elem.append(this.htmlTemplate(sortOrder > 0 ? Arrow.up : Arrow.down));
    }
};


$('.sortable-col').click(
    function () {
        var $obj = $(this);

        Arrow.handle($obj, sortOrder);

        var column_num = parseInt($obj.index());
        //var column_type = $obj.data('type');
        var $tbody = $obj.parents('table').children('tbody');
        var $rowsToSort = $tbody.find('tr');

        $rowsToSort.sort(
            function (a, b) {
                var $a = $(a);
                var $b = $(b);
                var aVal = $($a.find('td').get(column_num)).text();
                var bVal = $($b.find('td').get(column_num)).text();
                //console.log(aVal > bVal);
                //console.log(aVal);
                if (aVal > bVal) {
                    return sortOrder;
                } else if (aVal < bVal) {
                    return -sortOrder;
                }

                return 0;
            });

        $tbody
            .empty()
            .append($rowsToSort);

        sortOrder *= -1;
    }
);